var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoyaltyCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0052 0.666695C8.88002 0.666695 0.671875 8.87484 0.671875 19C0.671875 29.1252 8.88002 37.3334 19.0052 37.3334C29.1303 37.3334 37.3386 29.1252 37.3386 19C37.3386 8.87484 29.1304 0.666695 19.0052 0.666695ZM25.9091 12.4499L28.5015 15.0424L17.1719 26.4195L10.3757 19.6233L12.9681 17.0308L17.1719 21.2346L25.9091 12.4499Z",
    fill: "#2F9F31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyCheck);
export default __webpack_public_path__ + "static/media/loyaltyCheck.c5cc94ea0c1455d60b5c837646543db3.svg";
export { ForwardRef as ReactComponent };